import request from '@/api/request'

// 登录
export const login = (data) => {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}
